import { forwardRef } from "react";
import type { IconProps } from "../shared";
import { Icon } from "../icon";
/** @preview ![icon](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ3aGl0ZSIvPjxwYXRoIGZpbGw9IiMxMTE5MjgiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTcuNzU3IDYuMzQzIDEyIDEwLjU4NWw0LjI0NC00LjI0MiAxLjQxNCAxLjQxNEwxMy40MTQgMTJsNC4yNDMgNC4yNDQtMS40MTQgMS40MTQtNC4yNDQtNC4yNDMtNC4yNDIgNC4yNDMtMS40MTQtMS40MTRMMTAuNTg1IDEyIDYuMzQzIDcuNzU4eiIgY2xpcC1ydWxlPSJldmVub2RkIi8+PC9zdmc+) */
export const IconClose = forwardRef<HTMLElement, IconProps>((props, ref) => (
    <Icon ref={ref} {...props}>
        <path
            fill="#111928"
            fillRule="evenodd"
            d="M7.757 6.343 12 10.585l4.244-4.242 1.414 1.414L13.414 12l4.243 4.244-1.414 1.414-4.244-4.243-4.242 4.243-1.414-1.414L10.585 12 6.343 7.758z"
            clipRule="evenodd"
        />
    </Icon>
));
IconClose.displayName = "IconClose";
